import React from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./caFreeTest.css";



// ——— Options ———
const STATES = [
  "Andhra Pradesh","Arunachal Pradesh","Assam","Bihar","Chhattisgarh","Goa","Gujarat",
  "Haryana","Himachal Pradesh","Jharkhand","Karnataka","Kerala","Madhya Pradesh",
  "Maharashtra","Manipur","Meghalaya","Mizoram","Nagaland","Odisha","Punjab","Rajasthan",
  "Sikkim","Tamil Nadu","Telangana","Tripura","Uttar Pradesh","Uttarakhand","West Bengal",
  "Andaman and Nicobar Islands","Chandigarh","Dadra & Nagar Haveli and Daman & Diu",
  "Delhi","Jammu & Kashmir","Ladakh","Puducherry"
];

const EMPLOYEES = [
  { id: "", name: "Select" },
  // add your employees or fetch dynamically
  { id: "emp01", name: "Counsellor 1" },
  { id: "emp02", name: "Counsellor 2" },
];

const schema = yup.object({
  name: yup.string().trim().required("Name is required"),
  mobile: yup.string().trim().matches(/^[6-9]\d{9}$/, "Enter valid 10-digit mobile").required(),
  email: yup.string().trim().email("Enter valid email").required(),
  state: yup.string().required("State is required"),
  city: yup.string().trim().required("City is required"),
  address: yup.string().trim().required("Address is required"),
  landmark: yup.string().trim().nullable(),
  pincode: yup.string().trim().matches(/^\d{6}$/, "Enter valid 6-digit pincode").required(),
  employee: yup.string().nullable()
});

export default function CAFoundationFreeTest() {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting }
  } = useForm({ resolver: yupResolver(schema) });

   React.useEffect(() => {
    const header = document.querySelector("header");
    if (header) {
      document.documentElement.style.setProperty(
        "--ed-header-height",
        header.offsetHeight + "px"
      );
    }
  }, []);

  // Toggle ONE of the two flows below depending on how your codebase handles payment:
  //  A) If your app already has a Payment page/route that reads query params (common in your build),
  //     just navigate to it (fastest).
  //  B) If your flow creates an order via API first, call that endpoint, then redirect.

 const onSubmit = async (values) => {
  // Build a real <form> and submit it — no axios/fetch
  const apiBase = process.env.REACT_APP_API_URL; // e.g. "https://yourdomain.com/Apiweb/"

  const form = document.createElement("form");
  form.method = "POST";
  form.action = `${apiBase}free_test_payment_link`;
  form.target = "_self"; // use "_blank" to open in new tab if you prefer
  form.style.display = "none";

  const fields = {
    fullname: values.name,
    mobile_no: values.mobile,
    email: values.email,
    additional_information: JSON.stringify({
      source: "ca-foundation-free-test",
      state: values.state,
      city: values.city,
      address: values.address,
      landmark: values.landmark || "",
      pincode: values.pincode || "",
      employee: values.employee || "",
    }),
  };

  Object.entries(fields).forEach(([name, value]) => {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit(); // browser navigates to your API, renders HTML, auto-submits to CCAvenue
};



  const Input = ({ label, error, children }) => (
    <div className="ed-input">
      {label && <label className="ed-label">{label}</label>}
      {children}
      {error && <div className="ed-error">{error.message}</div>}
    </div>
  );

  return (
    <div className="ed-section">
      <div className="ed-container">
        <h1 className="ed-title">CA Foundation Free Test for Sept 2025</h1>

        <div className="ed-grid">
          {/* Left: Form */}
          <div className="ed-card">
            <h2 className="ed-subtitle">Student Information</h2>

            <form onSubmit={handleSubmit(onSubmit)} noValidate>
              <Input label="Enter Name" error={errors.name}>
                <input type="text" placeholder="Enter Name" {...register("name")} />
              </Input>

              <Input label="Enter Mobile" error={errors.mobile}>
                <input type="tel" placeholder="Enter Mobile" inputMode="numeric" {...register("mobile")} />
              </Input>

              <Input label="Enter Email" error={errors.email}>
                <input type="email" placeholder="Enter Email" {...register("email")} />
              </Input>

              <div className="ed-row">
                <Input label="Select State" error={errors.state}>
                  <select {...register("state")} defaultValue="">
                    <option value="" disabled>Select State</option>
                    {STATES.map(s => <option key={s} value={s}>{s}</option>)}
                  </select>
                </Input>
                <Input label="Enter City" error={errors.city}>
                  <input type="text" placeholder="Enter City" {...register("city")} />
                </Input>
              </div>

              <Input label="Address Line" error={errors.address}>
                <textarea rows={4} placeholder="Address Line" {...register("address")} />
              </Input>

              <div className="ed-row">
                <Input label="Landmark" error={errors.landmark}>
                  <input type="text" placeholder="Landmark" {...register("landmark")} />
                </Input>
                <Input label="Pincode" error={errors.pincode}>
                  <input type="text" placeholder="Pincode" inputMode="numeric" {...register("pincode")} />
                </Input>
              </div>

              {/* <Input label="Which employee helped you purchase?" error={errors.employee}>
                <select {...register("employee")} defaultValue="" style>
                  {EMPLOYEES.map(e => <option key={e.id} value={e.id}>{e.name}</option>)}
                </select>
              </Input> */}

              <p className="ed-note">Do not use special characters like @, $, &, #, %, etc.</p>

              <div className="ed-actions-mobile">
                <button className="ed-btn" type="submit" disabled={isSubmitting}>
                  {isSubmitting ? "Please wait..." : "REVIEW & PAY"}
                </button>
              </div>
            </form>
          </div>

          {/* Right: Order Summary */}
          <div className="ed-card ed-summary">
            <h2 className="ed-subtitle">Order Summary</h2>
            <div className="ed-summary-line">
              <span>CAFC Free Test for Sept 2025</span>
              <span>Rs. 1/-</span>
            </div>
            <hr />
            <div className="ed-summary-line ed-total">
              <span>Total</span>
              <span>Rs. 1/-</span>
            </div>

            <button
              className="ed-btn ed-btn-full"
              onClick={handleSubmit(onSubmit)}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Please wait..." : "REVIEW & PAY"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
// add after useForm(...)



